export default function isPricePerPerson(
  entity: any,
  quantity: number
): number {
  if (!entity?.isPricePerPerson) return 1;
  return quantity;
}
